import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "min-w-0 w-full" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "relative min-w-0" }
const _hoisted_4 = ["id", "disabled", "value"]
const _hoisted_5 = ["value"]

export type AdminSelectOption = { value: string; label: string };


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminFormSelectField',
  props: {
    modelValue: {},
    options: {},
    label: {},
    selectId: { default: "admin-select-field" },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onChange = (e: Event) => {
  emit("update:modelValue", (e.target as HTMLSelectElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: __props.selectId,
          class: "block text-xs sm:text-sm font-semibold text-slate-700 mb-1.5"
        }, _toDisplayString(__props.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", {
        id: __props.selectId,
        disabled: __props.disabled,
        value: __props.modelValue,
        class: "w-full min-w-0 appearance-none pl-3 pr-9 py-2.5 sm:py-3 text-sm border border-slate-300 rounded-lg sm:rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-red-500/30 focus:border-red-500 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed truncate",
        onChange: onChange
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt) => {
          return (_openBlock(), _createElementBlock("option", {
            key: `${__props.selectId}-${opt.value}`,
            value: opt.value
          }, _toDisplayString(opt.label), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_4),
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        class: "pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        })
      ], -1))
    ])
  ]))
}
}

})